import { render, staticRenderFns } from "./TareasDashBoardComponent.vue?vue&type=template&id=d1615a4c&"
import script from "./TareasDashBoardComponent.vue?vue&type=script&lang=js&"
export * from "./TareasDashBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports